import cn from 'classnames';
import { MutableRefObject, ReactNode } from 'react';

import { AutoshipmentFodBanner } from '@zooplus/autoshipment-checkout-front';
import { Seller, useCheckoutContext } from '@zooplus/checkout-state';
import { FlatBox } from '@zooplus/ui-components';

import FeedbackMessage from '../../../common/notifications/feedback-message';
import CartAutoshipment from '../../cart-autoshipment';

import commonStyles from '@styles/common.module.scss';
import { CHECKOUT_STATE_PROJECT_ID, MESSAGE_PLACEMENT } from '@utilities/constants';

import CartShipmentHeader from './cart-shipment-header/cart-shipment-header';
import styles from './cart-shipment.module.scss';

type CartShipmentProps = {
  seller: Seller;
  id: number;
  children?: ReactNode;
  index: number;
  totalShipments: number;
  is1P: boolean;
  shippingCost?: number;
  shipmentTotal: number;
  keyCloackToken: MutableRefObject<string | undefined>;
  isFirstOrderDiscountAvailable?: boolean;
};

const CartShipment = ({
  seller,
  id,
  children,
  index,
  totalShipments,
  is1P,
  shippingCost,
  shipmentTotal,
  keyCloackToken,
  isFirstOrderDiscountAvailable,
}: CartShipmentProps) => {
  const { isFetching } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);

  return (
    <>
      <FlatBox
        className={styles.shipmentContainer}
        data-testid="cart-shipment"
        variant="white"
        rounded>
        <CartShipmentHeader
          seller={seller}
          index={index}
          totalShipments={totalShipments}
          shippingCost={shippingCost}
          shipmentTotal={shipmentTotal}
        />
        {is1P && (
          <div
            className={cn(
              styles.warning,
              !isFirstOrderDiscountAvailable && commonStyles.hideWrapper,
            )}>
            {!isFetching && <AutoshipmentFodBanner />}
          </div>
        )}
        <FeedbackMessage
          placement={MESSAGE_PLACEMENT.SHIPMENT_CONTAINER_HEADER}
          customStyle={styles.warning}
          shipmentId={id}
        />
        <FeedbackMessage
          placement={MESSAGE_PLACEMENT.SHIPMENT_DELIVERY_OPTIONS}
          customStyle={styles.warning}
          shipmentId={id}
        />
        <FlatBox
          className={styles.shipmentBodyContainer}
          variant="white"
          rounded
          data-testid="cart-shipment-articles">
          {children}
        </FlatBox>
      </FlatBox>
      {is1P && <CartAutoshipment keyCloackToken={keyCloackToken} />}
    </>
  );
};

export default CartShipment;
